import React from "react";
import PropTypes from "prop-types";
import {
  Card,
  CardHeader,
  Button,
  ListGroup,
  ListGroupItem,
  Progress
} from "shards-react";

const UserProfile = ({ item }) => (
  <Card small className="mb-4 pt-3">
    <CardHeader className="border-bottom text-center">
      <div className="mb-3 mx-auto">
        <img
          className="rounded-circle"
          src={item.profile}
          alt={item.name}
          width="110"
        />
      </div>
      <h4 className="mb-0">{item.name}</h4>
      <span className="text-muted d-block mb-2">{item.department}</span>
     {/*  <Button pill outline size="sm" className="mb-2">
        <i className="material-icons mr-1">person_add</i> Follow
      </Button> */}
    </CardHeader>
    <ListGroup flush>
    {/*   <ListGroupItem className="px-4">
        <div className="progress-wrapper">
          <strong className="text-muted d-block mb-2">
            {item.performanceReportTitle}
          </strong>
          <Progress
            className="progress-sm"
            value={item.performanceReportValue}
          >
            <span className="progress-value">
              {item.performanceReportValue}%
            </span>
          </Progress>
        </div>
      </ListGroupItem> */}
      <ListGroupItem className="p-4">
        <strong className="text-muted d-block mb-2">
          Email
        </strong>
        <span>{item.email}</span>
      </ListGroupItem>

      <ListGroupItem className="p-4">
        <strong className="text-muted d-block mb-2">
          Phone
        </strong>
        <span>{item.phone}</span>
      </ListGroupItem>

     

      
      
    </ListGroup>
  </Card>
);

export default UserProfile;
